const common = {
  KEY_FAVORITE: 'favorite',
  KEY_BASKET: 'basket',
};




export { common };